export default function moneyFormat(number) {
    return Intl.NumberFormat('ru-Ru', { style: 'currency', currency: 'rub' }).format(number / 100);
}
